import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const tableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
        label: '预约编号',
        prop: 'visitCode',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '预约人',
        prop: 'appointmentPersonName',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '访客姓名',
        prop: 'visitorsName',
        search: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '预约状态',
        prop: 'status',
        search: true,
        searchSlot: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24,
        formatter: function (row, value) {
          return value == 1 ? '待审批': value == 2 ? '已通过': value == 3 ? '已拒绝': value == 4 ? '已签入': value == 5 ? '已签离': '暂无';
        }
      },
      {
        label: '来访人数',
        prop: 'visitorsNumber',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '预约时间',
        prop: 'appointmentDates',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      },
      {
        label: '来访时间',
        prop: 'startTime',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        type: 'datetimerange',
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24,
        formatter: function (row, value) {
          return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        }
      }
    ]
  }
}